<template>
    <div class="service-container" @click="openService">
        <div v-if="questions.length" class="question-carousel">
            <div
                    v-for="(question, index) in questions"
                    :key="index"
                    class="question-item"
                    :class="{ active: currentIndex === index }"
            >
                {{ question }}
            </div>
        </div>

        <button class="service-button" ><van-icon name="service" badge="6" /></button>
    </div>
</template>
<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue';
import open53 from "@/api/seviceBtn"

const props = defineProps({
    questions: {
        type: Array,
        default: () => []
    },
    affim: {
        type: String,
        default: ''
    }
})

const currentIndex = ref(0);
let rotationInterval = null;

const colorSchemes = [
    { name: 'tech-blue', bgColor: '#0052D9', textColor: '#FFFFFF', btnColor1: '#1A73E8', btnColor2: '#4285F4', btnRgb: '66, 133, 244' },
    { name: 'vibrant-orange', bgColor: '#FF6D00', textColor: '#FFFFFF', btnColor1: '#FF9100', btnColor2: '#FFAB40', btnRgb: '255, 171, 64' },
    { name: 'fresh-green', bgColor: '#00C853', textColor: '#FFFFFF', btnColor1: '#00E676', btnColor2: '#69F0AE', btnRgb: '105, 240, 174' },
    { name: 'passion-red', bgColor: '#D50000', textColor: '#FFFFFF', btnColor1: '#FF1744', btnColor2: '#FF5252', btnRgb: '255, 82, 82' },
    { name: 'mystic-purple', bgColor: '#6200EA', textColor: '#FFFFFF', btnColor1: '#7C4DFF', btnColor2: '#B388FF', btnRgb: '179, 136, 255' }
];

const rotateQuestions = () => {
    currentIndex.value = (currentIndex.value + 1) % props.questions.length;
};

const openService = () => {
    open53(props.affim)
};

const applyRandomColorScheme = () => {
    const randomScheme = colorSchemes[Math.floor(Math.random() * colorSchemes.length)];
    document.documentElement.style.setProperty('--bg-color', randomScheme.bgColor);
    document.documentElement.style.setProperty('--text-color', randomScheme.textColor);
    document.documentElement.style.setProperty('--btn-color1', randomScheme.btnColor1);
    document.documentElement.style.setProperty('--btn-color2', randomScheme.btnColor2);
    document.documentElement.style.setProperty('--btn-rgb', randomScheme.btnRgb);
};

onMounted(() => {
    applyRandomColorScheme();
    if (props.questions.length) {
        rotationInterval = setInterval(rotateQuestions, 3500);
    }
});

onBeforeUnmount(() => {
    if (rotationInterval) {
        clearInterval(rotationInterval);
    }
});
</script>

<style scoped>
.service-container {
    position: fixed;
    right: .875rem;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    z-index: 1000;
}

@keyframes breath {
    0% { box-shadow: 0 0 0 0 rgba(var(--btn-rgb), 0.7); }
    70% { box-shadow: 0 0 0 0.9375rem rgba(var(--btn-rgb), 0); }
    100% { box-shadow: 0 0 0 0 rgba(var(--btn-rgb), 0); }
}

.service-button {
    width: 3.75rem;
    height: 3.75rem;
    border-radius: 50%;
    background: linear-gradient(135deg, var(--btn-color1), var(--btn-color2));
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    animation: breath 2s infinite;
    font-size: 1.5rem;
    border: none;
    outline: none;
    transition: all 0.3s;
}

.service-button:hover {
    transform: scale(1.1);
}

.question-carousel {
    width: 12.5rem;
    background: var(--bg-color);
    border-radius: 0.5rem;
    padding: 0.5rem 0.75rem;
    box-shadow: 0 0.125rem 0.625rem rgba(0, 0, 0, 0.1);
    margin-bottom: 0.9375rem;
    text-align: center;
    font-size: 0.875rem;
    color: var(--text-color);
    overflow: hidden;
    min-height: 1.875rem;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 1.4;
}

.question-item {
    position: absolute;
    width: 100%;
    text-align: center;
    opacity: 0;
    transition: opacity 1s ease-in-out;
    padding: 0.125rem 0.625rem;
    box-sizing: border-box;
}

.question-item.active {
    opacity: 1;
}
</style>
